<div class="bank-component">
  <mat-card appearance="outlined">
      <div class="row">
        <div class="col-12">
          <div class="mat-h3">
            Bank Statements
            @if (isInternalUser(loggedInUser) && (canRefreshBankStatement || canRefreshBasiq)) {
              <button mat-icon-button
                      [matTooltip]="'Refresh'"
                      (click)="refreshBankStatement()"
                      class="w-lt-md-100">
                <span class="mdi mdi-refresh-circle cursor-pointer" matSuffix></span>
              </button>
            }
          </div>
        </div>
      </div>


    @if (bankStatementMessage) {
      <div class="row">
        <div class="col-lg-9 col-md-12">
          <message-box type="warn">
            {{bankStatementMessage}}
          </message-box>
        </div>
      </div>
    }
    @if(isAllConsentsRevokedOrExpired){
      <div class="row">
        <div class="col-lg-9 col-md-12">
          <message-box type="warn">
            All consents are revoked or expired. Please generate a new link to continue.
          </message-box>
        </div>
      </div>
    }

    @if (bankStatementNotAvailable) {
      <div class="row">
        <div class="col-lg-9 col-md-12">
          <message-box type="warn">
            Bank statement is not available for this applicant.
          </message-box>
        </div>
      </div>
    }
    @if (bankStatementInfo && !bankStatementNotAvailable) {
      <div class="row">
        <div class="col-lg-9 col-md-12">
          <message-box type="info">
            {{bankStatementInfo}}
          </message-box>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-lg-9 col-md-12">
          <div
            fxLayout="row"
            fxLayout.lt-md="column"
            fxLayoutAlign="space-between center"
            fxLayoutGap="pxToRem(5)"
            fxLayoutAlign.lt-md="center start">
            <button mat-flat-button
                    class="w-lt-md-100"
                    [cdkCopyToClipboard]="formControlBankStatementLink.value ?? ''">
              <span class="mdi mdi-content-copy cursor-pointer" matSuffix [cdkCopyToClipboard]="formControlBankStatementLink.value ?? ''"></span>
              <span class="label"> Regenerate the link </span>
            </button>
          </div>
        </div>
      </div>
    }

    @if (!hasBankStatement && !hasBasiqStatement && !bankStatementInfo && !bankStatementNotAvailable) {
      <div class="bank-statements-request">
        <div class="hero">
          <div class="hero-icon" aria-hidden="true">
            <span class="mdi mdi-bank-plus"></span>
          </div>
          <div class="hero-text">
            <h2>Request the customer's bank statements</h2>
            <p class="lead">
              Share the link below with the customer. They'll connect via Illion or Basiq and their
              statements will land in this application automatically.
            </p>
            <mat-form-field appearance="outline" class="link-field">
              <mat-label>Bank statement link</mat-label>
              <input matInput type="text" readonly [formControl]="formControlBankStatementLink">
              <button mat-icon-button matSuffix
                      [matTooltip]="'Copy link'"
                      [cdkCopyToClipboard]="formControlBankStatementLink.value ?? ''">
                <span class="mdi mdi-content-copy"></span>
              </button>
            </mat-form-field>
          </div>
        </div>
      </div>
    }

    @if ((hasBankStatement || hasBasiqStatement) && !showStatementResults && !bankStatementNotAvailable) {
      <div class="bank-statements-received">
        <div class="hero">
          <div class="hero-icon" aria-hidden="true">
            <span class="mdi mdi-check-decagram"></span>
          </div>
          <div class="hero-text">
            <h2>Bank statements received</h2>
            <p class="lead">
              Thanks &mdash; our credit team has received the submitted bank statements
              and is reviewing them as part of this application.
            </p>
            @if (submittedTime) {
              <p class="meta">Submitted {{submittedTime}}</p>
            }
          </div>
        </div>

        <div class="sources-grid">
          @if (hasBankStatement) {
            <div class="source-card">
              <span class="source-icon mdi mdi-bank-check"></span>
              <div class="source-body">
                <strong>Illion bank statements</strong>
                <span class="source-status">Received &amp; under review</span>
              </div>
              <span class="source-tick mdi mdi-check-circle"></span>
            </div>
          }
          @if (hasBasiqStatement) {
            <div class="source-card">
              <span class="source-icon mdi mdi-link-variant"></span>
              <div class="source-body">
                <strong>Basiq open banking</strong>
                <span class="source-status">Connected &amp; under review</span>
              </div>
              <span class="source-tick mdi mdi-check-circle"></span>
            </div>
          }
        </div>

        <div class="next-step">
          <div class="next-step-header">
            <span class="mdi mdi-share-variant-outline"></span>
            <span>Need to share the upload link again?</span>
          </div>
          <p class="next-step-help">
            Re-share this link with the customer if a fresh submission is required.
            New statements flow straight into this application.
          </p>
          <mat-form-field appearance="outline" class="link-field">
            <mat-label>Bank statement link</mat-label>
            <input matInput type="text" readonly [formControl]="formControlBankStatementLink">
            <button mat-icon-button matSuffix
                    [matTooltip]="'Copy link'"
                    [cdkCopyToClipboard]="formControlBankStatementLink.value ?? ''">
              <span class="mdi mdi-content-copy"></span>
            </button>
          </mat-form-field>
        </div>
      </div>
    }

    @if(hasBankStatement && hasBasiqStatement && showStatementResults && !bankStatementNotAvailable){
      <div class="row">
        <div class="col-12 mb-2">
          <p class="description">
            This applicant has provided bank statements through both Basiq and Illion platforms.
            You can review and analyze the financial data from either source using the selector below.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-md-8 col-sm-12">
          <div class="source-selection">
            <mat-form-field>
              <mat-label>Select Statement Source</mat-label>
              <mat-select [(ngModel)]="selectedStatementSource" (selectionChange)="onStatementSourceChange()">
                <mat-option value="basiq">Basiq</mat-option>
                <mat-option value="illion">Illion</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    }



    @if (showStatementResults && ((hasBankStatement && !hasBasiqStatement) || (hasBankStatement && hasBasiqStatement && selectedStatementSource == 'illion') && !bankStatementNotAvailable)) {

      <bank-statement
      [reference]="reference"
      [getBankStatementsAnalysisFn]="getBankStatementsAnalysisFn"
        [refreshBankStatementFn]="refreshBankStatementFn"
        [updateDscrCalculatorValueFn]="updateDscrCalculatorValueFn"
        [getDscrCalculatorValueFn]="getDscrCalculatorValueFn"
        [saveBsaCalculatorFn]="saveBsaCalculatorFn"
        [getBsaCalculatorFn]="getBsaCalculatorFn"
        [apiUrl]="apiUrl"
        [bankStatementsUrl]="bankStatementsUrl"
        [getBsaLenderListFn]="getBsaLenderListFn"
        [getBsaExcludedLenderListFn]="getBsaExcludedLenderListFn"
        [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
        [createApplicationNoteFn]="createApplicationNoteFn"
        [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
        [getDscrCalculatorHistoryFn]="getDscrCalculatorHistoryFn"
      [application]="application"
      ></bank-statement>
      }

      @if(showStatementResults && ((!hasBankStatement && hasBasiqStatement) || (hasBankStatement && hasBasiqStatement && selectedStatementSource == 'basiq') && !bankStatementNotAvailable)) {

        <bank-statement
        type="Basiq"
        [reference]="reference"
        [getBankStatementsAnalysisFn]="getBankStatementsAnalysisFn"
        [refreshBankStatementFn]="refreshBankStatementFn"
        [updateDscrCalculatorValueFn]="updateDscrCalculatorValueFn"
        [getDscrCalculatorValueFn]="getDscrCalculatorValueFn"
        [saveBsaCalculatorFn]="saveBsaCalculatorFn"
        [getBsaCalculatorFn]="getBsaCalculatorFn"
        [apiUrl]="apiUrl"
        [bankStatementsUrl]="bankStatementsUrl"
        [getBsaLenderListFn]="getBsaLenderListFn"
        [getBsaExcludedLenderListFn]="getBsaExcludedLenderListFn"
        [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
        [createApplicationNoteFn]="createApplicationNoteFn"
        [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
        [getDscrCalculatorHistoryFn]="getDscrCalculatorHistoryFn"
      [application]="application"
      [getBasiqCustomerMappingByAbnFn]="getBasiqCustomerMappingByAbnFn"
        [getBasiqStatementDataForCompanyFn]="getBasiqStatementDataForCompanyFn"
        [refreshBasiqConnectionsFn]="refreshBasiqConnectionsFn"
      ></bank-statement>
      }
    </mat-card>
  </div>
